var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrivacy = function SvgPrivacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.5 2.127 13.167 4.2v3.133c0 3.014-1.987 5.794-4.667 6.62-2.68-.826-4.667-3.606-4.667-6.62V4.2zm0-1.46-6 2.666v4c0 3.7 2.56 7.16 6 8 3.44-.84 6-4.3 6-8v-4zm-.667 4h1.334V6H7.833zm0 2.666h1.334v4H7.833z"
  })));
};
export default SvgPrivacy;